"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _createFocusRingStyles = require("../../util/createFocusRingStyles");
var _withFocusClassName = require("../../util/withFocusClassName");
var _TabsContext = require("./TabsContext");
var _tabsTheme = require("./tabsTheme");
const StyledTabPanel = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("div")(_ref => {
  let {
    themeMode
  } = _ref;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: themeMode,
    componentRadius: _tabsTheme.tabsTheme.focusRingRadius(themeMode),
    gap: _tabsTheme.tabsTheme.focusRingGap(themeMode),
    componentBorderWidth: 0
  });
}));
StyledTabPanel.displayName = "StyledTabPanel";
const TabPanel = /*#__PURE__*/(0, _react.forwardRef)((_ref2, parentRef) => {
  let {
    children,
    id,
    ...rest
  } = _ref2;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    onlyRenderActiveTabPanelChildren,
    registerTabPanel,
    selectedId,
    tabRegistrations
  } = (0, _TabsContext.useTabsContext)();
  const localRef = (0, _react.useRef)(null);
  const ref = (0, _lodestarUtils.useForkRef)(localRef, parentRef);
  const finalId = (0, _react.useMemo)(() => id ?? (0, _lodestarUtils.genId)("smar--tab--panel"), [id]);
  const thisReg = tabRegistrations.find(_ref3 => {
    let {
      panelRef
    } = _ref3;
    return panelRef?.current === localRef.current;
  });
  const isSelected = thisReg?.tabId === selectedId;
  (0, _react.useEffect)(() => {
    if (localRef.current) {
      const {
        unregister
      } = registerTabPanel(finalId, localRef);
      return unregister;
    }
  }, [finalId, registerTabPanel]);
  return /*#__PURE__*/_react.default.createElement(StyledTabPanel, (0, _extends2.default)({}, rest, {
    themeMode: themeMode,
    ref: ref,
    role: "tabpanel",
    tabIndex: isSelected ? 0 : -1,
    id: finalId,
    "aria-labelledby": thisReg?.tabId,
    style: {
      display: isSelected ? undefined : "none"
    },
    hidden: !isSelected
  }), onlyRenderActiveTabPanelChildren ? isSelected ? children : null : children);
});
exports.TabPanel = TabPanel;
TabPanel.displayName = "TabPanel";
//# sourceMappingURL=TabPanel.js.map